import { DeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";

export class DevicesState {
    deviceTree: DeviceTreeNode[] = [];
}
export default new DevicesState();
